import React from 'react'
import styled from 'styled-components'

export const baseUrl = '/#/mobility-utils'

const Examples = (): JSX.Element => {
    return (
        <div style={{ top: 50, position: 'relative', padding: '24px' }}>
            <h1>Components examples</h1>
            <StyledUl>
                <li>
                    <a href={baseUrl + '/navbar'}>Navbar</a>
                </li>
                <li>
                    <a href={baseUrl + '/header'}>Header</a>
                </li>
                <li>
                    <a href={baseUrl + '/list-header'}>ListHeader</a>
                </li>
                <li>
                    <a href={baseUrl + '/form-header'}>FormHeader</a>
                </li>
                <li>
                    <a href={baseUrl + '/dropdown-filters'}>DropdownFilters</a>
                </li>
                <li>
                    <a href={baseUrl + '/task'}>Task</a>
                </li>
            </StyledUl>
        </div>
    )
}
export default Examples

export const BackButton = styled.a`
    &::after {
        content: '<- Back';
        width: 100px;
        height: 50px;
        color: 'blue';
        text-decoration: underline;
        cursor: pointer;
        padding: 4px 8px;
        border-radius: 4px;
        border: 1px solid blue;
    }
`

const StyledUl = styled.ul`
    list-style: circle;
    li {
        margin-bottom: 16px;
        a:hover {
            text-decoration: underline;
        }
    }
`
